import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA52uZL2NSseYma7MZGovmBw6_3watpxp0",
  authDomain: "woollim-teacher.firebaseapp.com",
  projectId: "woollim-teacher",
  storageBucket: "woollim-teacher.firebasestorage.app",
  messagingSenderId: "667319478206",
  appId: "1:667319478206:web:65acff2630dec4e2097bef",
  measurementId: "G-R96ZCNWGYT"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
